export default __webpack_public_path__ + "static/media/icon-very-sad-face-full.23925c25.svg";